import axiosInstance from './axiosInstance';

const getBalanceGraphById = (balanceId) =>
  axiosInstance.get(`/internal/admin/balances/${balanceId}/graphs`);

export default getBalanceGraphById;
